import axios from 'axios';

// 登录请求方法
const loginreq = (method, url, params) => {
    return axios({
        method: method,
        url: url,
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
        },
        data: params,
        traditional: true,
    }).then(res => res);
};
// 通用公用方法
const req = (method, url, params) => {
    return axios({
        method: method,
        url: url,
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            token: localStorage.getItem('logintoken')
        },
        data: params,
        traditional: true,
    }).then(res => res);
};
//图片公共方法
const reqblob = (method, url) => {
    return axios({
        method: method,
        url: url,
        responseType: 'blob',
    }).then(res => {
        let blob = res;
        //转换为图片路径
        let src = window.URL.createObjectURL(blob)
        //src直接放到img src路径中就可以了
        return src;
    });
};

//文件公共方法
const reqfile = (method, url, params) => {
    return axios({
        method: method,
        url: url,
        data: params,
        responseType: 'blob',
    }).then(res => res);
};

export {
    loginreq,
    req,
    reqblob,
    reqfile
}


// WEBPACK FOOTER //
// ./src/api/axiosFun.js